import * as React from 'react';
import styled from 'styled-components'

interface IProps
    extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
}

const AvatarMiddleDefault: React.SFC<IProps> = (props) => {

    const { ...ImgProps } = props;

    return (<img {...ImgProps} />)

};

const AvatarMiddle = styled(AvatarMiddleDefault)`
    width: 100px;
    height: 100px;
    border-radius: 50%; 
    object-fit: cover;
`;

export default AvatarMiddle;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/avatar/avatar_middle.tsx